export default "__VITE_ASSET__DIV2E_Mz__"